import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": `${siteUrl}/#business`,
          "name": "Quality First Construction LLC",
          "description": "Professional construction and remodeling services in the southwest suburbs of Chicago. Specializing in kitchen remodeling, bathroom renovation, home remodeling, and repairs. Family owned and operated with 40 years of experience.",
          "url": siteUrl,
          "telephone": "+17087077211",
          "email": "KKSvihla@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Southwest Suburbs",
            "addressRegion": "IL",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 41.7377,
            "longitude": -87.8620
          },
          "areaServed": {
            "@type": "Place",
            "name": "Southwest Suburbs of Chicago, Illinois"
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "18:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Saturday"],
              "opens": "09:00",
              "closes": "16:00"
            }
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Construction & Remodeling Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Kitchen Remodeling",
                  "description": "Transform your kitchen into a modern culinary space with custom cabinets and premium finishes.",
                  "offers": { "@type": "Offer", "priceCurrency": "USD", "price": "15000", "priceSpecification": { "@type": "PriceSpecification", "minPrice": "15000" } }
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Bathroom Renovation",
                  "description": "Create your perfect spa-like retreat with elegant fixtures and contemporary design.",
                  "offers": { "@type": "Offer", "priceCurrency": "USD", "price": "8000", "priceSpecification": { "@type": "PriceSpecification", "minPrice": "8000" } }
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Home Repairs",
                  "description": "Carpentry, plumbing, electrical repairs.",
                  "offers": { "@type": "Offer", "priceCurrency": "USD", "price": "50000", "priceSpecification": { "@type": "PriceSpecification", "minPrice": "50000" } }
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Home Remodeling",
                  "description": "Full-scale home transformations including basements, rec rooms, bars, laundry rooms, and more.",
                  "offers": { "@type": "Offer", "priceCurrency": "USD", "price": "20000", "priceSpecification": { "@type": "PriceSpecification", "minPrice": "20000" } }
                }
              }
            ]
          },
          "foundingDate": "1985",
          "slogan": "Quality First",
          "knowsAbout": ["construction", "remodeling", "home renovation", "kitchen remodeling", "bathroom renovation", "home additions"]
        },
        {
          "@type": "WebSite",
          "@id": `${siteUrl}/#website`,
          "url": siteUrl,
          "name": "Quality First Construction LLC",
          "description": "Professional construction and remodeling services in the southwest suburbs of Chicago.",
          "publisher": { "@id": `${siteUrl}/#business` }
        },
        {
          "@type": "WebPage",
          "@id": `${siteUrl}/#webpage`,
          "url": siteUrl,
          "name": "Quality First Construction LLC | Southwest Suburbs Chicago",
          "description": "Professional construction and remodeling services in the southwest suburbs of Chicago. Specializing in kitchen remodeling, bathroom renovation, home remodeling, and repairs.",
          "isPartOf": { "@id": `${siteUrl}/#website` },
          "about": { "@id": `${siteUrl}/#business` },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": siteUrl }
            ]
          }
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.text = JSON.stringify(schema);
    const existing = document.getElementById('schema-home');
    if (existing) existing.remove();
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
